import { render, staticRenderFns } from "./LabelInput.vue?vue&type=template&id=1f9e2c6b&"
import script from "./LabelInput.vue?vue&type=script&lang=ts&"
export * from "./LabelInput.vue?vue&type=script&lang=ts&"
import style0 from "./LabelInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports